export default "__VITE_ASSET__D1$u76eB__"